import OpenDiscussionButton from '../TicketList/OpenDiscussionButton/OpenDiscussionButton';
import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { toast } from 'react-toastify';
import { TextField } from "@mui/material";
import Popup from 'reactjs-popup';
import { FormControl } from "@mui/material";
import { Select } from "@mui/material";
import { MenuItem } from "@mui/material";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useDispatch, useSelector } from "react-redux";
import { updateTicket, assignTicketToMe, fetchTicketById, setSelectedTicket, assignTicketToSupport } from '../../../slices/TicketSlice';
import { fetchSupportUsers } from '../../../slices/userSlice';  
import Draggable from "react-draggable";
import "./TicketDetailedView.scss";
import TicketChickenTest from './TicketChickenTest/TicketChickenTest';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';

export default function TicketDetailedView({ onClose }) {
  const dispatch = useDispatch();
  const ticket = useSelector((state) => state.tickets.selectedTicket);
  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();
  const supportUsers = useSelector((state) => state.user.usersList);
  const [selectedId, setSelectedId] = useState(ticket?.assigneeId || "UNASSIGNED");

  const role = user?.roles?.map(r => r.authority) || [];
  const hasRole = (roleName) => role.includes(roleName);

  const [showEdit, setShowEdit] = useState(false);
  const [editFields, setEditFields] = useState({
    assigneeName: ticket?.assigneeName || "",
    description: ticket?.description || ""
  });

  const theme = createTheme({ typography: { fontFamily: "'Poppins', sans-serif" } });
 useEffect(() => {
    if (ticket?.id && !ticket.description) {
      dispatch(fetchTicketById(ticket.id));
    }
  }, [dispatch, ticket?.id, ticket?.description]);

  useEffect(() =>{
    if(hasRole("ROLE_ADMIN")){
      dispatch(fetchSupportUsers());
    };
  }, [dispatch, user]
);
  //If there is a selected ticket call fetchTicketById method to set the detailed information like description
  useEffect(() => {
    if (ticket && !ticket.description) {
      dispatch(fetchTicketById());
    }
  }, [dispatch, ticket]); 

  // Keep the dropdown selection in sync when the ticket's assignee changes (e.g., "Assign to me")
  useEffect(() => {
    if (ticket) {
      setSelectedId(ticket.assigneeId || "UNASSIGNED");
    }
  }, [ticket?.assigneeId]);
const isInvalidAssignee = (currentassignee, newassignee) => {
    let isInvalid = false;
    if(currentassignee !== "UNASSIGNED" && currentassignee !== null && newassignee === "UNASSIGNED"){
      isInvalid = true;
    }
    return isInvalid;
  };
  const isInvalidStatusTransition = (currentStatus, newStatus) => {
    
    // Disables setting the current ticket to the same status it already has
    if (currentStatus === newStatus) {
      return true;
    }

    // If the ticket is currently CLOSED, it shouild stay COLSED
    if (currentStatus === "CLOSED" && newStatus !== "CLOSED") {
      return !hasRole("ROLE_ADMIN");
    }
    
    let isInvalid = false;
    
    switch (currentStatus) {
      case "UNASSIGNED":
        // Invalid if NOT moving to CLOSED and NOT moving to IN_PROGRESS
        // Only CLOSED or IN_PROGRESS are valid
        isInvalid = newStatus !== "CLOSED" && newStatus !== "IN_PROGRESS";
        break;
      case "IN_PROGRESS":
      case "BLOCKED":
      case "RESOLVED":
        // Invalid if trying to move back to UNASSIGNED
        // Any status except UNASSIGNED is valid (IN_PROGRESS, BLOCKED, RESOLVED, CLOSED)
        isInvalid = newStatus === "UNASSIGNED";
        break;
      
      case "CLOSED":
        // Invalid if trying to move to anything other than CLOSED
        // Only CLOSED is valid
        isInvalid = newStatus !== "CLOSED";
        break;
      default:
        isInvalid = false;
    }

    return isInvalid;
  };

const handleStatus = async (evt) => {
    const newStatus = evt.target.value;
    const currentStatus = ticket.status;

    // If the user selects the same status the ticket already has, do nothing
    if (newStatus === currentStatus) return;

    if (isInvalidStatusTransition(currentStatus, newStatus)) {
      toast.error(`Invalid status transition: ${currentStatus} -> ${newStatus}`);
      return; // Exit here - no API call is made
    }

    const updates = newStatus === "UNASSIGNED"
        ? { status: newStatus, assigneeName: "" }
        : { status: newStatus };

    try {
      // Use .unwrap() to catch the rejection in the try/catch block
      await dispatch(updateTicket({ 
        ticketId: ticket.id, 
        updates 
      })).unwrap();
      
      toast.success("Status updated successfully!");
    } catch (err) {
      toast.error(err || "An error occurred while updating status");
      dispatch(fetchTicketById(ticket.id)); // Re-fetch to ensure UI is in sync with DB after failure
    }
  };

  const handleAssignToMe = async () => {
    if (!ticket) return;

    if (ticket.status === "CLOSED") {
      toast.error("Status changes are final. You cannot assign a closed ticket.");
      return; // Exit here - no API call is made
    }

    try {
      await dispatch(assignTicketToMe(ticket.id)).unwrap();
      toast.success("Ticket assigned successfully.");
    } catch (err) {
      toast.error(err || "Assignment failed");

      // Optional: Re-fetch the ticket to ensure UI is perfectly synced with DB
      dispatch(fetchTicketById(ticket.id));
    }
  };
  const handleAssignToSupport = async (event) => {
    if (!ticket) return;

    if (ticket.status === "CLOSED") {
      toast.error("Status changes are final, you must reopen the ticket if you wish to assign it.");
      return;
    }
    try {
      const val = event.target.value;
      const assignId = val === "UNASSIGNED" ? val : Number(val);      
      setSelectedId(assignId);
      if(assignId !== "UNASSIGNED"){
        console.log("it went through")
        await dispatch(assignTicketToSupport({
          ticketId: ticket.id,
          supportUserId: assignId
        })).unwrap();
        toast.success("Ticket assigned successfully!");
        
      }
    } catch (err) {
      toast.error(err || "Assignment failed");
      dispatch(fetchTicketById(ticket.id));
    }
  };

const rawCreation = ticket?.createdAt ?? "N/A";
  //Assigned date is set to N/A since it hasn't been assigned yet
  const rawAssigned = ticket?.assignedAt ?? "N/A";

  const formatTimestamp = (rawDate) => {

    // Handle empty/null/undifed dates
    if (!rawDate) return "";

    // Convert to ISO format if not already
    const iso = rawDate.includes("T") ? rawDate : rawDate.replace(" ", "T");

    // Ensure is in UTC
    const utc = iso.endsWith("Z") ? iso : iso + "Z";

    return new Date(utc).toLocaleString("en-US", {
      timeZone: 'America/Chicago',
      year: '2-digit', // 2-digit year (26 for 2026)
      month: 'numeric', // month without leading zero (3 for March)
      day: 'numeric', // day without leading zero (3 for 3th)
      hour: 'numeric', // hour without leading zero (9 for 9 AM))
      minute: '2-digit', // minute with leading zero (09 for 9 minutes)
      hour12: true // 12-hour format with AM/PM (9:09:03 AM)
    });
  };

  const displayCreationDate = formatTimestamp(rawCreation);
  let displayAssignedDate = formatTimestamp(rawAssigned);
  //Sets time to CST
  const displayAssignee = ticket?.assigneeName ?? ticket?.assignee ?? ticket?.assignedTo ?? "N/A";
  //Date function would return Invalid Date for empty or invalid dates so I replaced it with N/A
  if(displayAssignedDate === "Invalid Date") {
    displayAssignedDate = "N/A";
  }

  if(!ticket) {
    return null;
  }

  const handleCloseTicket = () => {
    dispatch(setSelectedTicket(null));
    navigate("/", {replace: true});
    onClose && onClose();
  }
  return (
  <Draggable
  handle=".ticket-drag-handle"
  cancel="
    button,
    input,
    textarea,
    select,
    option,
    a,
    [role='button'],
    .MuiButtonBase-root,
    .MuiSelect-select
  "
>
<div data-testid="ticket-detailed-view" className="ticket-card">
      <button className="exit-btn" onClick={() => {handleCloseTicket(); if(onClose){onClose();}}} data-testid="exit-button">X</button>
      <div className="ticket-content" data-testid="ticket-content">
        <div className="ticket-header ticket-drag-handle" data-testid="ticket-header">
          <h2 className="ticket-heading" data-testid="ticket-heading">
            Ticket Title: <br /> {ticket.title} <br />
            Ticket Number: {ticket.id} <br /> <br />
            
          </h2>
          {(hasRole("ROLE_SUPPORT") || hasRole("ROLE_ADMIN")) && (
            <ThemeProvider theme={theme}>
              <Button className = "assign-to-me-btn"
                variant="text"
                sx={{ fontFamily: 'Poppins' }}
                onClick={handleAssignToMe} 
                disabled={ticket.status === "CLOSED" || ticket.assigneeId === user.id}
                data-testid="assign-to-me-button"
              >
                {ticket.status === "CLOSED" ? "Ticket Closed" : "Assign to me"}
              </Button>
            </ThemeProvider>
          )}
        </div>
        <div className="ticket-detail-and-status" data-testid="ticket-detail-and-status">
            <div className="ticket-details" data-testid="ticket-details">
            <p data-testid="ticket-creation-date">Ticket Creation Date: {displayCreationDate}</p>
            <p data-testid="ticket-assignee">Ticket Assignee: {displayAssignee}</p>
            <p data-testid="ticket-assigned-date">Assigned Date: {displayAssignedDate}</p>
          </div>
      <div className="dropdowns" data-testid="dropdowns">
        <label className="dropdown-label" data-testid="dropdown-label">
          <div className="dropdown-status-wrapper" data-testid="dropdown-status-wrapper">
            {(hasRole("ROLE_SUPPORT") || hasRole("ROLE_ADMIN")) ? (
              <FormControl data-testid="form-control">
                  <p className="label"></p>Ticket Status
                  <Select
                    data-testid="dropdown-button1"
                    className="dropdown-status"
                    value={ticket.status || ''}
                    onChange={handleStatus}
                    displayEmpty
                    disabled={ticket.status === "CLOSED"}
                  >
                    <MenuItem value="UNASSIGNED" disabled={isInvalidStatusTransition(ticket.status, "UNASSIGNED")} data-testid="status-unassigned-option">
                    Select Status
                    </MenuItem>
                    <MenuItem value="IN_PROGRESS" disabled={isInvalidStatusTransition(ticket.status, "IN_PROGRESS")} data-testid="status-in-progress-option">
                      In Progress
                    </MenuItem>
                    <MenuItem value="BLOCKED" disabled={isInvalidStatusTransition(ticket.status, "BLOCKED")} data-testid="status-blocked-option">
                      Blocked
                    </MenuItem>
                    <MenuItem value="RESOLVED" disabled={isInvalidStatusTransition(ticket.status, "RESOLVED")} data-testid="status-resolved-option">
                      Resolved
                        </MenuItem>
                    {ticket.status === "CLOSED" && (
                    <MenuItem value="CLOSED" disabled={isInvalidStatusTransition(ticket.status, "CLOSED")} data-testid="status-closed-option">
                      Closed
                    </MenuItem>
                    )}
                 </Select>
              </FormControl>
            ) : (
              <p className="status-text" data-testid="current-status">
                Current Status: {ticket.status}
              </p>
            )}
          </div>
          </label>
        <div className="dropdown-assign-wrapper" data-testid="dropdown-assign-wrapper">
          {(hasRole("ROLE_ADMIN")) ? (
            <FormControl data-testid="form-control">
              <label className="dropdown-label" data-testid="dropdown-label">
                <p className="label">Support User</p>
                <Select
                  data-testid="dropdown-button2"
                  className="dropdown-assign"
                  value={selectedId}
                  onChange={handleAssignToSupport}
                  displayEmpty
                  disabled={ticket.status === "CLOSED"}
                  >
                    <MenuItem value="UNASSIGNED" disabled={isInvalidAssignee(ticket.assigneeId, "UNASSIGNED")}>
                      Select Assignee
                    </MenuItem> 
                    {supportUsers && supportUsers.map((sUser) =>(
                    <MenuItem key={sUser.id} value={sUser.id} data-testid={`support-option-${sUser.id}`}>
                      {sUser.firstName} {sUser.lastName}
                    </MenuItem>
                    ))}
                  </Select>
                </label>
            </FormControl>
          ) : null}
        </div>
      </div>
        </div>

        <Box
          sx={{
            height: "150px",
            overflowY: "auto",
            overflowX: "hidden",
            padding: "16px",
            fontFamily: "'Poppins, sans-serif'",
            display: "block",
            backgroundColor: "#a6a6a6",
            textAlign: "left",
            borderRadius: "8px",
          }}
        >
          <Typography variant="caption" sx={{display: "block", fontWeight: "bold", fontSize: "16px", color: "black"}} className="description-field">
            Description:
          </Typography>
          <Typography sx={{whiteSpace: "pre-wrap", wordBreak: "break-word", fontFamily: "'Poppins', sans-serif", display: "block", textAlign: "left", color: "black"}} className="description-input-root" data-testid="ticket-description">
            {ticket.description || ""}
          </Typography>
          </Box>
        {showEdit && (
          <div className="edit-overlay">
            <div className="edit-modal">
              <div className="edit-inner">
                <button className="modal-close-x" aria-label="Close" data-testid="close-edit-btn" onClick={() => setShowEdit(false)}> × </button>
                <div className="modal-row">
                  <label>Ticket Assignee:</label>
                  <FormControl fullWidth size="small">
                    <TextField
                      value={editFields.assigneeName}
                      onChange={(e) =>
                        setEditFields({ ...editFields, assigneeName: e.target.value })
                      }
                      className="modal-input"
                      data-testid="edit-assignee-input"
                    />
                  </FormControl>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div
      className={`ticket-buttons ${
        ticket.status === "CLOSED" ? "closed-ticket-buttons" : ""
      }`}
    >
      <div className="ticket-button">
        <OpenDiscussionButton data-testid="open-discussion-button" />
      </div>

      {(hasRole("ROLE_ADMIN") || hasRole("ROLE_SUPPORT")) &&
      ticket.status !== "CLOSED" && (
        <div className="ticket-button">
          <Popup
            modal
            nested
            trigger={
              <Tooltip
                title="Sets the Ticket Status to Closed"
                placement="right"
                arrow
                enterDelay={500}
                enterNextDelay={500}
              >
                <Button
                  variant="contained"
                  className="close-btn"
                  data-testid="close-ticket-button"
                >
                  Close Ticket
                </Button>
              </Tooltip>
            }
          >
            {close => (
              <TicketChickenTest
                onClose={close}
                mode="complete"
                ticketId={ticket.id}
              />
            )}
          </Popup>
        </div>
      )}
      </div>
      </div>
      </Draggable>

      );
      }
